import React, { Component } from "react";

class SearchCategory extends Component {
	render() {
		return (
			<div>
				{this.props.items.length ? (
					<table className="display_table">
						<thead>
							<tr className="table-header">
								<th />
								<th>Title</th>
								<th>Top Category</th>
								<th>Hidden</th>
								<th />
							</tr>
						</thead>
						<tbody>
							{this.props.items.map((item, i) => (
								<tr
									className="clickable"
									key={i}
									onClick={() =>
										this.props.history.push(this.props.basePath + "/" + item.id)
									}
								>
									<td className="record-number">
										{i + this.props.startPosition + 1}
									</td>
									<td data-id="Title">{item.title}</td>
									<td data-id="Top Category">{!item.parent_id ? "Yes" : "No"}</td>
									<td data-id="Hidden">{item.hidden ? "Yes" : "No"}</td>
									<td className="edit-cell">
										<div className="edit_btn">View</div>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				) : (
					<div>No Results</div>
				)}
			</div>
		);
	}
}

SearchCategory.defaultProps = {
	items: [],
	startPosition: 0,
	clickHandle: null
};

export default SearchCategory;



// WEBPACK FOOTER //
// ./src/components/search/SearchCategory.js